<template>
<div>
  <div class="row">
    <div class="col">
    <!-- Cell 1 -->
    <CellTakt :cellID="1" :cell-takt-scans="taktCell_1" />
    </div>
    <div class="col">
    <!-- Cell 2 -->
    <CellTakt :cellID="2" :cell-takt-scans="taktCell_2" style="background-color: lightgrey;"/>
    </div>
  </div>
  <hr/>
  <div class="row">
    <div class="col">
    <!-- Cell 3 -->
    <CellTakt :cellID="3" :cell-takt-scans="taktCell_3" style="background-color: lightgrey;"/>
    </div>
    <div class="col">
    <!-- Cell 4 -->
    <CellTakt :cellID="4" :cell-takt-scans="taktCell_4" />
    </div>
  </div>
</div>
</template>

<script>
import server from '../../api/server'
import moment from 'moment'
import CellTakt from './cell_takt.vue'

export default {
  name: 'scanTaktCell',
  data() {
    return {
      taktCell_1: [],
      taktCell_2: [],
      taktCell_3: [],
      taktCell_4: []
    }
  },
  methods: {
    get_scanTaktCellData() {
      server.getScanTaktCell().then(res => {
        this.taktCell_1 = res.data.cell_1
        this.taktCell_2 = res.data.cell_2
        this.taktCell_3 = res.data.cell_3
        this.taktCell_4 = res.data.cell_4
      })
      this.setProtectedTimeout(this.get_scanTaktCellData, 5000)
    }
  },
  mounted: function() {
    this.get_scanTaktCellData()
  },
  components: { CellTakt }
}
</script>

<style scoped>
.label_margin {
  display: block;
  margin: 0px 0 5px 0;
}
.badge-time {
  font-size: 1rem;
  margin-bottom: 5px;
}
hr {
  margin: 5px 0px 30px 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/andon/scan_takt_cell.vue